  export enum ProjectStatus {
      Preparation = 1,
      Started = 2,
      Completed = 3
  }